module.exports = __webpack_public_path__ + "img/ThemeIcons.3b333b0d.svg";